import React from 'react';

const Icon = () => {
    return (
        <svg width="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 15.9C0 10.3938 0 7.64071 1.05455 5.53021C2.02249 3.59308 3.59308 2.02249 5.53021 1.05455C7.64071 0 10.3938 0 15.9 0H24.1C29.6062 0 32.3593 0 34.4698 1.05455C36.4069 2.02249 37.9775 3.59308 38.9454 5.53021C40 7.64071 40 10.3938 40 15.9V24.1C40 29.6062 40 32.3593 38.9454 34.4698C37.9775 36.4069 36.4069 37.9775 34.4698 38.9454C32.3593 40 29.6062 40 24.1 40H15.9C10.3938 40 7.64071 40 5.53021 38.9454C3.59308 37.9775 2.02249 36.4069 1.05455 34.4698C0 32.3593 0 29.6062 0 24.1V15.9Z"
                fill="#DED9FB"
            />
            <path
                d="M28.5002 20.6726H25.1159C23.8732 20.6718 22.866 19.6499 22.8652 18.3883C22.8652 17.1266 23.8732 16.1047 25.1159 16.1039H28.5002"
                stroke="#7033FF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.4985 18.3359H25.238"
                stroke="#7033FF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.887 11H24.1128C26.5357 11 28.4998 12.9942 28.4998 15.4541V21.5459C28.4998 24.0058 26.5357 26 24.1128 26H16.887C14.4642 26 12.5 24.0058 12.5 21.5459V15.4541C12.5 12.9942 14.4642 11 16.887 11Z"
                stroke="#7033FF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.292 14.8519H20.8055"
                stroke="#7033FF"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
